<template>
  <div class="containerTime table-responsive col-12">
    <li
      style="
        display: block;
        color: #000000;
        font-family: dfyuanstd-w5, dfyuanstd-w3;
        font-size: 1rem;
      "
    >
      總出貨時間
    </li>
    <b-table
      :items="containerTimeItem"
      :fields="containerTimeFields"
      class="text-center containerTime-table-detail"
    >
    </b-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "containerTime",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      containerTimeFields:
        "containerTime/get_containerTimeFields",
      containerTimeItem:
        "containerTime/get_containerTimeItem",
    }),
  },
};
</script>

<style lang="scss">
.containerTime-table-detail thead th {
  border-top: 1px solid;
}
.containerTime-table-detail th,
.containerTime-table-detail td {
  font-size: 1rem;
  min-width: 65px;
  padding: 0.1rem;
  border-color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  background-color: #ffffff;
  vertical-align: middle !important;
}
.containerTime-table-detail th:first-child,
.containerTime-table-detail td:first-child {
  border-left: 1px solid;
}
.containerTime-table-detail {
  margin-bottom: 0px;
}
.containerTime-table-detail thead th {
  color: #000000 !important;
  background-color: #cccccc !important;
}
</style>



// WEBPACK FOOTER //
// src/components/containerTime.vue